var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { CloseWithoutBorder } from '../../../assets/images';
import { secondary } from '../../../theme/colors';
var TaxDetailsPopup = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            name: 'header',
            p: 2,
            spacing: 0,
            bgcolor: secondary[50],
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'headername',
                    children: 'Tax details',
                    fontSize: 'xl',
                    fontWeight: 'strong',
                    //   sx:{padding:'10px 0px 5px 16px'},
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    label: '',
                    name: '',
                    //   sx:{paddingTop:'10px'},
                    value: null,
                    columnSize: 1,
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: CloseWithoutBorder
                    }),
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            p: 3,
            name: '',
            elements: [{
                    type: FormItemTypes.Typography,
                    label: 'Tax (%)',
                    sx: {
                        alignItems: 'center'
                    },
                    name: 'Tax',
                    columnSize: 6,
                    fontSize: 'xl',
                    fontWeight: 'medium',
                    setFieldProps: function (formValues) {
                        var _formValues$SavedPric;
                        var totalTax = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric = formValues.SavedPriceWithTax) === null || _formValues$SavedPric === void 0 || (_formValues$SavedPric = _formValues$SavedPric.Taxes) === null || _formValues$SavedPric === void 0 || _formValues$SavedPric.forEach(function (taxItem) {
                            totalTax += taxItem.TaxComponentPercentage;
                        });
                        return {
                            value: "".concat(totalTax.toFixed(2))
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'Tax (₹)',
                    name: 'TaxAmount',
                    columnSize: 6,
                    fontSize: 'xl',
                    fontWeight: 'medium',
                    setFieldProps: function (formValues) {
                        var _formValues$SavedPric2;
                        var totalTax = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric2 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric2 === void 0 || (_formValues$SavedPric2 = _formValues$SavedPric2.Taxes) === null || _formValues$SavedPric2 === void 0 || _formValues$SavedPric2.forEach(function (taxItem) {
                            totalTax += taxItem.TaxComponentAmount;
                        });
                        return {
                            value: "".concat(totalTax.toFixed(2))
                        };
                    }
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        height: 'auto'
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'SGST/UTGST (%)',
                    name: 'SGST_UTGST_Percentage',
                    value: null,
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric3;
                        var sgstAmount = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric3 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric3 === void 0 || (_formValues$SavedPric3 = _formValues$SavedPric3.Taxes) === null || _formValues$SavedPric3 === void 0 || _formValues$SavedPric3.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "SGST") {
                                sgstAmount = taxItem.TaxComponentPercentage;
                            }
                        });
                        return sgstAmount.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'SGST/UTGST (₹)',
                    name: 'SGST_UTGST_Amount',
                    value: null,
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric4;
                        var sgstAmount = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric4 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric4 === void 0 || (_formValues$SavedPric4 = _formValues$SavedPric4.Taxes) === null || _formValues$SavedPric4 === void 0 || _formValues$SavedPric4.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "SGST") {
                                sgstAmount = taxItem.TaxComponentAmount;
                            }
                        });
                        return sgstAmount.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'CGST (%)',
                    name: 'CGSTPercentage',
                    value: null,
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric5;
                        var cgstPercentage = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric5 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric5 === void 0 || (_formValues$SavedPric5 = _formValues$SavedPric5.Taxes) === null || _formValues$SavedPric5 === void 0 || _formValues$SavedPric5.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "CGST") {
                                cgstPercentage = taxItem.TaxComponentPercentage;
                            }
                        });
                        return cgstPercentage.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'CGST (₹)',
                    name: 'CGSTAmount',
                    value: null,
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric6;
                        var cgstAmount = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric6 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric6 === void 0 || (_formValues$SavedPric6 = _formValues$SavedPric6.Taxes) === null || _formValues$SavedPric6 === void 0 || _formValues$SavedPric6.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "CGST") {
                                cgstAmount = taxItem.TaxComponentAmount;
                            }
                        });
                        return cgstAmount.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'IGST (%)',
                    name: 'IGSTPercentage',
                    value: null,
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric7;
                        var igstPercentage = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric7 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric7 === void 0 || (_formValues$SavedPric7 = _formValues$SavedPric7.Taxes) === null || _formValues$SavedPric7 === void 0 || _formValues$SavedPric7.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "IGST") {
                                igstPercentage = taxItem.TaxComponentPercentage;
                            }
                        });
                        return igstPercentage.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    label: 'IGST (₹)',
                    name: 'IGSTAmount',
                    columnSize: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric8;
                        var igstAmount = 0;
                        formValues === null || formValues === void 0 || (_formValues$SavedPric8 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric8 === void 0 || (_formValues$SavedPric8 = _formValues$SavedPric8.Taxes) === null || _formValues$SavedPric8 === void 0 || _formValues$SavedPric8.forEach(function (taxItem) {
                            if (taxItem.TaxComponentName === "IGST") {
                                igstAmount = taxItem.TaxComponentAmount;
                            }
                        });
                        return igstAmount.toFixed(2) || 0;
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            hidden: Number(field === null || field === void 0 ? void 0 : field.value) === 0
                        };
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    }));
};
export default TaxDetailsPopup;
